/* eslint-disable no-undef, no-console, no-unneeded-ternary, prefer-destructuring, no-param-reassign, default-param-last */

window.mpConsentManager = {
	cookieExpire: 365, // days
	maxAttempts: 3,
	consent: {
		name: 'mp_consent',
		value: 'first',
	},
	// piwik needs consent manager to be active and custom consent manager toggle enabled for this to work
	marketing: {
		name: 'mp_marketing_consent',
		value: 1,
		set(analyticsConsent, marketingConsent) {
			marketingConsent = marketingConsent ? 1 : 0;
			mpConsentManager.setCookie(mpConsentManager.marketing.name, marketingConsent);
			mpConsentManager.marketing.value = marketingConsent;
			mpConsentManager.piwik.set(analyticsConsent, marketingConsent);
		},
		get() {
			return mpConsentManager.getCookie(mpConsentManager.marketing.name);
		},
	},
	piwik: {
		name: 'mp_piwik_consent',
		value: 1,
		set(analyticsConsent, marketingConsent) {
			analyticsConsent = analyticsConsent ? 1 : 0;
			marketingConsent = marketingConsent ? 1 : 0;
			const piwikConsents = {
				analytics: { status: analyticsConsent },
				remarketing: { status: marketingConsent },
			};

			const sendPiwikConsent = (status) => {
				window.ppms.cm.api(
					'setComplianceSettings',
					{ consents: piwikConsents },
					() => console.log(`Piwik consent tracking: ${status}`),
					(error) => console.error('Piwik consent error:', error),
				);
			};

			mpConsentManager.try(() => {
				if (typeof ppms !== 'undefined' && window.ppms.cm && window.ppms.cm.api) {
					sendPiwikConsent(
						analyticsConsent === 1 ? 'trackAgreeToAllClick' : 'trackRejectAllClick',
					);
					mpConsentManager.setCookie(mpConsentManager.piwik.name, analyticsConsent);
					mpConsentManager.piwik.value = analyticsConsent;
					return true;
				}
				return false;
			}, 'Piwik consent API is not available.');
		},
		get() {
			const getPiwikConsent = () => {
				window.ppms.cm.api(
					'getComplianceSettings',
					(settings) => console.log(settings.consents),
					(error) => console.error('Piwik consent error:', error),
				);
			};
			mpConsentManager.try(() => {
				if (typeof window.ppms !== 'undefined' && window.ppms.cm && window.ppms.cm.api) {
					getPiwikConsent();
					return true;
				}
				return false;
			}, 'Piwik consent API is not available.');
		},
		check() {
			const cookies = document.cookie.split('; ');
			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i].split('=');
				if (cookie[0].startsWith('ppms_privacy')) {
					return true;
				}
			}
			return false;
		},
	},
	getCookie(cookieName) {
		const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`));
		if (!cookie) return null;
		return cookie.split('=')[1];
	},
	setCookie(cookieName, value) {
		const date = new Date();
		const cookieDomain = window.location.hostname.includes('mindpath.com')
			? 'domain=.mindpath.com'
			: '';
		if (value === false) {
			value = 0;
		}
		if (value === true) {
			value = 1;
		}
		date.setTime(date.getTime() + this.cookieExpire * 24 * 60 * 60 * 1000);
		document.cookie = `${cookieName}=${value};expires=${date.toUTCString()};path=/;${cookieDomain}`;
	},
	dismiss() {
		this.close();
		this.setCookie(this.consent.name, 'dismissed');
		const analyticsCookie = this.piwik.value === 0 || this.piwik.value === '0' ? 0 : 1;
		const marketingCookie = this.marketing.value === 0 || this.marketing.value === '0' ? 0 : 1;
		// marketing cookie calls piwik too (used as a trigger for both)
		this.marketing.set(analyticsCookie, marketingCookie);
	},
	reject() {
		// marketing cookie calls piwik too (used as a trigger for both)
		this.marketing.set(0, 0);
		this.setCookie(this.consent.name, 'decline');
		this.close();
	},
	accept() {
		// marketing cookie calls piwik too (used as a trigger for both)
		this.marketing.set(1, 1);
		this.setCookie(this.consent.name, 'accepted');
		this.close();
	},
	close() {
		const consentManager = document.querySelector('.consent-manager');
		if (consentManager) {
			consentManager.remove();
		}
	},
	toggle(modifier) {
		const consentManager = document.querySelector('.consent-manager');
		if (consentManager) {
			if (modifier === 'open') {
				consentManager.classList.remove('consent-manager--seen');
				// change consent back to first so that if they close the consent they opt-in to consents per the language
				this.setCookie(this.consent.name, 'first');
			} else {
				consentManager.classList.add('consent-manager--seen');
			}
		}
	},
	toggleOptions() {
		this.setCookie(this.consent.name, 'custom');
		const consentManagerList = document.querySelector('.consent-manager__list');
		if (consentManagerList.hasAttribute('hidden')) {
			consentManagerList.removeAttribute('hidden');
		} else {
			consentManagerList.setAttribute('hidden', '');
		}
	},
	toggleCookieInfo(cookieToShow) {
		if (cookieToShow) {
			const cookieInfo = document.getElementById(cookieToShow);
			if (cookieInfo.style.display === 'block') {
				cookieInfo.style.display = 'none';
			} else {
				document.querySelectorAll('.consent-manager__cookie-info').forEach((info) => {
					info.style.display = 'none';
				});
				cookieInfo.style.display = 'block';
			}
		} else {
			document.querySelectorAll('.consent-manager__cookie-info').forEach((info) => {
				info.style.display = 'none';
			});
		}
	},
	render(modifier) {
		const piwikCookie = this.getCookie(mpConsentManager.piwik.name);
		const marketingCookie = this.getCookie(mpConsentManager.marketing.name);
		const analyticsChoice = piwikCookie === 0 || piwikCookie === '0' ? '' : 'checked';
		const marketingChoice = marketingCookie === 0 || marketingCookie === '0' ? '' : 'checked';
		const consentManagerHTML = this.html(modifier, analyticsChoice, marketingChoice);

		document.body.insertAdjacentHTML('beforeend', consentManagerHTML);
	},
	init() {
		// check for piwik cookie
		if (this.getCookie(this.piwik.name) === null) {
			this.setCookie(this.piwik.name, this.piwik.value);
		}

		// check for marketing cookie
		if (this.getCookie(this.marketing.name) === null) {
			this.setCookie(this.marketing.name, this.marketing.value);
		}

		const consentCookie = this.getCookie(this.consent.name);

		// check if the consent cookie has been created, if so change to 'seen', if not create as 'first' seen (changes consent look)
		if (consentCookie === 'first') {
			this.setCookie(this.consent.name, 'seen');
			this.render('seen');
		} else if (consentCookie === 'seen') {
			this.render('seen');
		} else if (consentCookie === null) {
			this.setCookie(this.consent.name, this.consent.value);
			this.render();
		} else {
			// do not render consent manager if cookie is set to 'accepted',  'declined', or 'dismissed' as an action was taken
		}

		// change values to be readable in console
		this.consent.value = this.getCookie(this.consent.name);
		this.piwik.value = this.getCookie(this.piwik.name);
		this.marketing.value = this.getCookie(this.marketing.name);
	},
	try(operation, errorMessage) {
		let attempts = 0;
		const interval = setInterval(() => {
			if (operation() || attempts >= this.maxAttempts) {
				clearInterval(interval);
				if (attempts >= this.maxAttempts) {
					console.error(errorMessage);
				}
			}
			attempts++;
		}, 2000);
	},
	html(modifier = '', analyticsChoice, marketingChoice) {
		return `
		<div class="consent-manager consent-manager--${modifier}">
			<a href="javascript:void(0);" class="consent-manager__toggle" id="consent-toggle" onclick="mpConsentManager.toggle('open');">Set your privacy preferences</a>
			<div class="consent-manager__copy">
				<p><b>Privacy on this site.</b> This website uses tracking technologies such as cookies to enable essential site functionality, as well as for analytics and marketing. By clicking “Accept All”, closing this banner, or by continuing to use this website without taking further action, you consent to the use of tracking technologies as described in our <a href="/privacy-policy/">Privacy Policy</a> and <a href="/california-notice-and-privacy/">California Notice at Collection & Privacy Policy</a>.</p>
				<ul class="consent-manager__list" hidden>
					<li class="consent-manager__list-item--disabled">
						<label class="switch" disabled>
							<input type="checkbox" class="switch__input" checked disabled>
							<span class="switch__slide"></span>
						</label>
						<span>Essential</span>
						<span class="icon icon--info" id="cookie-toggle-essential" onclick="mpConsentManager.toggleCookieInfo('cookie-essential');"></span>
					</li>
					<li>
						<label class="switch">
							<input type="checkbox" class="switch__input" id="consent-toggle-analytics" onchange="mpConsentManager.marketing.set(this.checked, document.getElementById('consent-toggle-marketing').checked);" ${analyticsChoice}>
							<span class="switch__slide"></span>
						</label>
						<span>Analytics</span>
						<span class="icon icon--info" id="cookie-toggle-analytics" onclick="mpConsentManager.toggleCookieInfo('cookie-analytics');"></span>
					</li>
					<li>
						<label class="switch">
							<input type="checkbox" class="switch__input" id="consent-toggle-marketing"  onchange="mpConsentManager.marketing.set(document.getElementById('consent-toggle-analytics').checked, this.checked);" ${marketingChoice}>
							<span class="switch__slide"></span>
						</label>
						<span>Marketing</span>
						<span class="icon icon--info" id="cookie-toggle-marketing" onclick="mpConsentManager.toggleCookieInfo('cookie-marketing');"></span>
					</li>
				</ul>
				<span class="consent-manager__cookie-info" id="cookie-essential">
					We use essential cookies that are strictly necessary for the basic functionality of our website.
				</span>
				<span class="consent-manager__cookie-info" id="cookie-analytics">
					We use PIWIK analytics to track how our website is used and improve user experience. No personal data is collected and personal identifiers are masked.
				</span>
				<span class="consent-manager__cookie-info" id="cookie-marketing">
					We use PIWIK to track how visitors interact with our website and to measure the effectiveness of our marketing campaigns. Conversion events may be shared with platforms like Google Ads and Facebook to improve campaign performance. This data is configured to avoid sharing protected health information with these platforms and is not used for retargeting or behavioral advertising.
				</span>
			</div>
			<div class="consent-manager__btns wp-block-buttons">
				<div class="wp-block-button is-style-primary">
					<button class="wp-element-button btn btn-large" id="consent-dismiss" onclick="mpConsentManager.accept();">Accept All</button>
				</div>
				<div class="wp-block-button is-style-primary">
					<button class="wp-element-button consent-manager__button--small btn" id="consent-decline" onclick="mpConsentManager.reject();">Reject All</button>
				</div>
				<div class="wp-block-button is-style-primary">
					<button class="wp-element-button consent-manager__button--small btn" id="consent-toggle-list" onclick="mpConsentManager.toggleOptions();">Settings</button>
				</div>
			</div>
			<button class="consent-manager__close" id="consent-close" onclick="mpConsentManager.dismiss();">X</button>
		</div>`;
	},
};

document.addEventListener('DOMContentLoaded', () => {
	mpConsentManager.init();

	const manageCookiesLink = document.querySelector('.open-consent-manager');

	if (manageCookiesLink) {
		manageCookiesLink.removeAttribute('href');
		manageCookiesLink.addEventListener('click', (event) => {
			event.preventDefault();
			mpConsentManager.render();
		});
	}
});
